var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckbox = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.854 4.604 6 12.457 2.146 8.604l.708-.708L6 11.043l7.147-7.147z"
})));
export default SvgCheckbox;